import { IAuthContext } from 'src/state/providers/AuthProvider';
import { IRequestGenerator } from '../CreateCaseRequestFactory';
import { ICreateCaseRequest } from 'src/state/slice/models/CaseLifecycleTypes';
import { DocumentDetails } from 'src/state/slice/models/CommonTypes';
import { DDMAttributes } from 'src/integration/ddm/providers/DDMAttributesProvider';
import { ITranslationContext } from 'src/state/providers/TranslationProvider';
import { ReferralInfo } from 'src/state/slice/createCaseSlice';
import { fetchAgencyName, fetchRole } from 'src/utilities/AuthParamHelper';
import { DEFAULT_PROGRAM_COUNTRY_US } from 'src/constants/GlobalConstants';

export class SustainabilityCreateCaseRequestImpl implements IRequestGenerator {
  private userContext: IAuthContext;
  private payload: any;
  private additionalData: { [key: string]: string };
  private attachments: DocumentDetails[];
  private ddmAttributes: DDMAttributes;

  constructor(
    userContext: IAuthContext,
    payload: any,
    additionalData: { [key: string]: string },
    attachments: DocumentDetails[],
    ddmAttributes: DDMAttributes,
  ) {
    this.userContext = userContext;
    this.payload = payload;
    this.additionalData = additionalData;
    this.attachments = attachments;
    this.ddmAttributes = ddmAttributes;
  }

  generateCreateCaseRequest(): ICreateCaseRequest {
    const referralInformation: ReferralInfo = {
      agency: fetchAgencyName(
        this.userContext.preferredAccountId,
        this.userContext.accountAttributes,
      ),
      country: DEFAULT_PROGRAM_COUNTRY_US,
      role: fetchRole(
        this.userContext.preferredAccountId,
        this.userContext.accountAttributes,
      ),
    };

    const updatedPayload = {
      ...this.payload,
      referralInformation: {
        ...this.payload.referralInformation, //referral information from from react json form
        ...referralInformation, //referral information appending agency, country, role.
      },
    };
    return {
      userId: this.userContext.customerId,
      accountId: this.userContext.preferredAccountId,
      clientId: this.userContext.clientId,
      ddmSchemaId: this.ddmAttributes.ddmSchemaId!,
      ddmSchemaVersion: this.ddmAttributes.ddmSchemaVersion!,
      caseTitle: this.payload.caseTitle,
      data: JSON.stringify(updatedPayload),
      documentList: this.attachments,
    };
  }
}
